<div class="admin-layout">
  <header class="admin-layout__header" [attr.inert]="isMenuOpen() ? '' : null">
    <button class="admin-layout__menu-button" type="button"
      aria-controls="admin-navigation" [attr.aria-expanded]="isMenuOpen()" (click)="toggleMenu()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M3 6h18M3 12h18M3 18h18" />
      </svg>
      <span>Menú</span>
    </button>
    <span class="admin-layout__title">{{ pageTitle() }}</span>
  </header>

  @if (isCompactLayout() && isMenuOpen()) {
    <div class="admin-layout__backdrop" aria-hidden="true" (click)="closeMenu()"></div>
  }

  @if (!isCompactLayout() || isMenuOpen()) {
    <div id="admin-navigation" class="admin-layout__navigation"
      [class.admin-layout__navigation--open]="isMenuOpen()"
      [attr.role]="isCompactLayout() ? 'dialog' : null"
      [attr.aria-modal]="isCompactLayout() ? 'true' : null"
      aria-label="Menú de administración"
      [cdkTrapFocus]="isCompactLayout() && isMenuOpen()"
      [cdkTrapFocusAutoCapture]="isCompactLayout()"
      (keydown.escape)="closeMenu()">
      <app-sidebar [appVersion]="appVersion" (logout)="logout()" (close)="closeMenu()" />
    </div>
  }

  <main class="admin-layout__content" [attr.inert]="isMenuOpen() ? '' : null">
    <router-outlet />
  </main>
</div>

<app-toast-container position="bottom-right" />
